import { render, staticRenderFns } from "./IlmoitusHallitusVastaukset.vue?vue&type=template&id=3373c050&scoped=true"
import script from "./IlmoitusHallitusVastaukset.vue?vue&type=script&lang=js"
export * from "./IlmoitusHallitusVastaukset.vue?vue&type=script&lang=js"
import style0 from "./IlmoitusHallitusVastaukset.vue?vue&type=style&index=0&id=3373c050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3373c050",
  null
  
)

export default component.exports